import { isDefined, isString } from '@/utils';
import { i18n } from '../i18n';
import type { Locale } from '../models';
import { NumberFormatNames } from '../models';
import { setDomElementAttribute } from '@/utils/lib/DomUtils';

export function setI18nLocale(locale: Locale): Locale {
  setLocaleToVueI18n(locale);
  setDomElementAttribute('html', 'lang', locale.substring(0, 2));
  return locale;
}

function setLocaleToVueI18n(locale: Locale): void {
  if (i18n.mode === 'legacy') {
    // eslint-disable-next-line functional/immutable-data
    i18n.global.locale = locale;
  } else {
    // eslint-disable-next-line functional/immutable-data
    (i18n.global.locale as any).value = locale;
  }
}

export function translate(key: string, props?: Record<string, string | number>): string | never {
  const value = isDefined(props) ? i18n.global.t(key, props) : i18n.global.t(key);
  if (!isString(value)) throw new Error(`Can't translate following key: "${value}"`);
  return value;
}

export function toCurrency(value: number): string {
  return i18n.global.n(value, NumberFormatNames.Currency);
}

export function toDecimal(value: number): string {
  return i18n.global.n(value, NumberFormatNames.Number);
}

export function toRoundedNumber(value: number): string {
  return i18n.global.n(value, NumberFormatNames.RoundedNumber);
}
